import { Predictions } from '@imaaagery/a3camera';

export type MeshPoint = { x: number; y: number };
export type MeshEdge = [number, number];

export const LOADING_MASK_POINT_IDS = [
	10, 151, 8, 168, 195, 4, 94,
	167, 165, 64, 209, 174, 245, 343, 153, 144, 33, 160, 158, 28, 223, 156, 162, 21, 54, 67, 69, 107, 55, 133, 189,
	393, 391, 294, 429, 399, 465, 114, 380, 373, 263, 387, 385, 258, 443, 383, 389, 251, 284, 297, 299, 336, 285, 362, 413,
];

export const ANALYSE_STATIC_MASK_POINT_IDS = [
	0, 2, 4, 6, 8, 10, 17, 21, 29, 37, 39, 46, 52, 54, 55, 58, 61, 64, 67, 69, 84, 91, 92, 105, 107, 111, 118, 122, 124, 127, 131, 136, 137, 144, 148, 149, 150, 151, 152, 153, 157, 164, 167, 172, 176, 177, 185, 186, 187, 193, 194, 195, 200, 205, 210, 212, 216, 217, 227, 231, 242, 243, 246, 247, 251, 264, 267, 269, 270, 284, 285, 291, 294, 297, 298, 299, 300, 314, 321, 323, 334, 336, 342, 346, 347, 351, 356, 360, 361, 362, 365, 372, 374, 377, 378, 379, 380, 385, 387, 389, 390, 391, 397, 400, 410, 417, 418, 426, 427, 430, 434, 437, 443, 445, 446, 451, 454, 462, 470,
];

const LOADING_MASK_FORCED_EDGES: MeshEdge[] = [
	[10, 69],
	[10, 151],
	[69, 151],
	[168, 8],
	[168, 189],
	[168, 413],
];

const ANALYSE_STATIC_MASK_PATHS = [
	[10, 297, 284, 251, 389, 356, 454, 323, 361, 288, 397, 365, 379, 378, 400, 377, 152, 148, 176, 149, 150, 136, 172, 58, 127, 21, 54, 67, 10],
	[67, 69, 151, 299, 297],
	[107, 66, 105, 52, 46, 124, 113, 111],
	[336, 295, 334, 282, 276, 353, 342, 346],
	[246, 157, 144, 156, 243, 242],
	[385, 387, 362, 390, 374, 372],
	[0, 267, 269, 270, 291, 321, 405, 17, 84, 146, 185, 39, 0],
	[4, 195, 2, 0, 72, 242],
	[6, 8, 10, 151, 195],
];

const ANALYSE_STATIC_MASK_FORCED_EDGES: MeshEdge[] = [
	[10, 69],
	[10, 299],
	[69, 54],
	[299, 284],
	[8, 107],
	[8, 336],
	[52, 55],
	[443, 285],
	[144, 111],
	[374, 346],
	[107, 69],
	[336, 299],
	[107, 105],
	[336, 334],
	[4, 217],
	[4, 437],
	[217, 118],
	[437, 347],
	[118, 205],
	[347, 426],
	[118, 137],
	[347, 323],
	[122, 231],
	[6, 451],
	[122, 217],
	[231, 144],
	[451, 374],
	[231, 118],
	[451, 347],
	[4, 131],
	[4, 360],
	[29, 124],
	[387, 446],
	[55, 470],
	[285, 385],
	[243, 153],
	[131, 118],
	[360, 347],
	[131, 205],
	[360, 426],
	[118, 177],
	[347, 361],
	[187, 118],
	[427, 347],
	[216, 187],
	[410, 427],
	[216, 58],
	[410, 397],
	[212, 58],
	[167, 92],
	[164, 391],
	[92, 64],
	[391, 294],
	[4, 64],
	[4, 294],
	[212, 210],
	[210, 172],
	[92, 205],
	[391, 426],
	[39, 92],
	[267, 391],
	[167, 39],
	[164, 267],
	[55, 243],
	[91, 210],
	[61, 210],
	[200, 194],
	[200, 418],
	[17, 194],
	[17, 418],
	[91, 194],
	[321, 418],
	[194, 150],
	[418, 378],
	[200, 152],
	[200, 148],
	[194, 210],
	[164, 37],
	[164, 242],
	[285, 8],
	[417, 6],
	[351, 195],
	[362, 351],
	[294, 462],
	[462, 391],
	[430, 291],
	[430, 418],
	[377, 200],
	[148, 194],
	[377, 418],
];

const ANALYSE_STATIC_MASK_BLOCKED_EDGES: MeshEdge[] = [
	[67, 105],
	[297, 334],
	[157, 144],
	[362, 374],
	[470, 144],
	[385, 374],
	[243, 242],
	[107, 157],
	[336, 362],
	[105, 29],
	[334, 387],
	[69, 52],
	[299, 443],
	[54, 46],
	[284, 342],
	[243, 144],
	[157, 246],
	[362, 390],
	[58, 127],
	[397, 356],
	[57, 153],
	[287, 380],
	[231, 131],
	[451, 360],
	[242, 0],
	[2, 37],
	[157, 153],
	[362, 380],
	[84, 185],
	[17, 267],
	[185, 212],
	[269, 291],
	[0, 39],
	[37, 267],
	[0, 167],
	[39, 91],
	[267, 321],
	[185, 91],
	[269, 321],
	[351, 122],
	[6, 437],
	[385, 380],
	[387, 390],
	[387, 362],
	[462, 242],
	[321, 17],
	[2, 167],
	[314, 200],
	[84, 200],
	[397, 291],
];

export const normalizeMeshPoint = (point: number[], width: number, height: number): MeshPoint => {
	const isNormalized = Math.abs(point[0]) <= 2 && Math.abs(point[1]) <= 2;
	return {
		x: isNormalized ? point[0] * width : point[0],
		y: isNormalized ? point[1] * height : point[1],
	};
};

export const getPredictionMeshPoints = (predictions: Predictions, width: number, height: number): MeshPoint[] => {
	const predictionData = predictions as Predictions & {
		mesh?: number[][];
		scaledMesh?: number[][];
	};
	const source = predictionData.keypoints?.length
		? predictionData.keypoints
		: predictionData.scaledMesh?.length
			? predictionData.scaledMesh
			: predictionData.mesh;

	return source?.map((point) => normalizeMeshPoint(point, width, height)) ?? [];
};

export const buildClosestPointEdges = (points: MeshPoint[], pointIds: number[], neighborCount = 3) => {
	const seen = new Set<string>();
	const validPointIds = pointIds.filter((pointId) => points[pointId]);

	return validPointIds.reduce<MeshEdge[]>((edges, start) => {
		const startPoint = points[start];
		const nearestPointIds = validPointIds
			.filter((end) => end !== start)
			.map((end) => {
				const endPoint = points[end];
				const dx = startPoint.x - endPoint.x;
				const dy = startPoint.y - endPoint.y;
				return { end, distance: dx * dx + dy * dy };
			})
			.sort((a, b) => a.distance - b.distance)
			.slice(0, neighborCount);

		nearestPointIds.forEach(({ end }) => {
			const key = start < end ? `${start}-${end}` : `${end}-${start}`;
			if (!seen.has(key)) {
				seen.add(key);
				edges.push([start, end]);
			}
		});

		return edges;
	}, []);
};

export const buildLoadingMaskEdges = (points: MeshPoint[]) => {
	const edges = buildClosestPointEdges(points, LOADING_MASK_POINT_IDS);
	const seen = new Set(edges.map(([start, end]) => start < end ? `${start}-${end}` : `${end}-${start}`));

	LOADING_MASK_FORCED_EDGES.forEach(([start, end]) => {
		if (!points[start] || !points[end]) return;

		const key = start < end ? `${start}-${end}` : `${end}-${start}`;
		if (!seen.has(key)) {
			seen.add(key);
			edges.push([start, end]);
		}
	});

	return edges;
};

const edgeKey = (start: number, end: number) => start < end ? `${start}-${end}` : `${end}-${start}`;

const blockedAnalyseStaticMaskEdges = new Set(ANALYSE_STATIC_MASK_BLOCKED_EDGES.map(([start, end]) => edgeKey(start, end)));

const addEdge = (edges: MeshEdge[], seen: Set<string>, points: MeshPoint[], start: number, end: number) => {
	if (!points[start] || !points[end] || start === end) return;

	const key = edgeKey(start, end);
	if (blockedAnalyseStaticMaskEdges.has(key)) return;

	if (!seen.has(key)) {
		seen.add(key);
		edges.push([start, end]);
	}
};

export const buildAnalyseStaticMaskEdges = (points: MeshPoint[]) => {
	const edges = buildClosestPointEdges(points, ANALYSE_STATIC_MASK_POINT_IDS, 3)
		.filter(([start, end]) => !blockedAnalyseStaticMaskEdges.has(edgeKey(start, end)));
	const seen = new Set(edges.map(([start, end]) => edgeKey(start, end)));
	const pointIds = new Set(ANALYSE_STATIC_MASK_POINT_IDS);

	ANALYSE_STATIC_MASK_PATHS.forEach((path) => {
		let previous: number | null = null;
		path.forEach((pointId) => {
			if (!pointIds.has(pointId) || !points[pointId]) return;
			if (previous !== null) {
				addEdge(edges, seen, points, previous, pointId);
			}
			previous = pointId;
		});
	});

	ANALYSE_STATIC_MASK_FORCED_EDGES.forEach(([start, end]) => addEdge(edges, seen, points, start, end));

	return edges;
};
